/**
 * @file font-weights.ts
 * @description Переключатель «Начертание» заголовков (phase19.16 Р1, Р1-7;
 * uiux-design-r1 §1, проект своих шрифтов §6): веса шрифта платформы или
 * загруженные веса своего шрифта магазина.
 */

import { isShopFontEntry, nearestFontWeight, type SiteFontRegistry } from "@chaiberi/shared";

/** Подписи начертаний. */
export const WEIGHT_LABELS: Readonly<Record<number, string>> = {
  300: "Светлое",
  400: "Обычное",
  500: "Среднее",
  600: "Полужирное",
  700: "Жирное",
  800: "Очень жирное",
};

export interface HeadingWeightChoice {
  options: Array<{ value: string; label: string; disabled?: boolean }>;
  value: number;
  /** Свой шрифт без жирного файла — подсказка «Добавьте его…». */
  missingBold: boolean;
}

/**
 * Варианты «Начертание» заголовков: у шрифта платформы — его веса, у своего —
 * загруженные; незагруженное жирное видно, но выключено (проект uiux §6).
 */
export function headingWeightChoice(key: string, current: number, registry: SiteFontRegistry): HeadingWeightChoice {
  const entry = registry.find(key);
  if (entry && isShopFontEntry(entry)) {
    const loaded = new Set<number>(entry.files.map((f) => f.weight));
    return {
      options: [400, 700].map((w) => ({ value: String(w), label: WEIGHT_LABELS[w] ?? String(w), disabled: !loaded.has(w) })),
      value: nearestFontWeight(key, current, registry),
      missingBold: !loaded.has(700),
    };
  }
  const weights = (entry?.weights ?? [400, 700]).filter((w) => WEIGHT_LABELS[w]);
  return {
    options: weights.map((w) => ({ value: String(w), label: WEIGHT_LABELS[w] ?? String(w) })),
    value: weights.includes(current) ? current : (weights[weights.length - 1] ?? 400),
    missingBold: false,
  };
}
